import React from 'react';
import {motion} from 'framer-motion'
import {fadeIn} from '../variants'
import Img1 from '../assets/Site1.png';
import Img2 from '../assets/site2.png';
import Img3 from '../assets/site3.png';
import Img5 from '../assets/site5.png';


const Work = () => {

  const email = 'merlinmap502@gmail.com';

  return (

<section className='section' id='work'>
<div className='container mx-auto'>
<div className='flex flex-col lg:flex-row gap-x-10'>
  
<div className='flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0'>

<div>
<h2 className='h2 leading-tight text-accent'>My latest <br />
 Work</h2>
 <p className='max-w-sm mb1-16'>
 This compilation of my latest projects offers a glimpse into my recent work.
  It's a reflection of my unrelenting passion for technology,
   demonstrated through a fusion of Laravel and Java expertise
    that has been integral to the majority of my projects.
    
 </p>


</div>




</div>







<div
className='flex-1 flex flex-col gap-y-10'>
<div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
<div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
<img className='group-hover:scale-125 transition-all duration-500' src={Img1} alt='' />
<div className='absolute -bottom-full left-12 group-hover:bottom-24 transaction-all duration-500 z50'><span className='text-gradient'>E-COMMERCE APP</span> </div>

<div className='absolute -bottom-full left-12 group-hover:bottom-14 transaction-all duration-700 z50'>
  <span className='text-3xl text-white'></span>
   </div>
   </div>


   </div>






<div
className='flex-1 flex flex-col gap-y-10'>
<a href='https://github.com/Mapatano/OnlineQuizSystem' target='_blank' rel='noopener noreferrer'>
<div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
<div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
<img className='group-hover:scale-125 transition-all duration-500' src={Img3} alt='' />
<div className='absolute -bottom-full left-12 group-hover:bottom-24 transaction-all duration-500 z50'><span className='text-gradient'>ONLINE EXAMINATION SYSTEM</span> </div>

<div className='absolute -bottom-full left-12 group-hover:bottom-14 transaction-all duration-700 z50'>
  <span className='text-3xl text-white'></span>
  
   </div>
   </div>
   </a>
   




   <div
className='flex-1 flex flex-col gap-y-10'>
  <a href='https://github.com/Mapatano/gymManagementSystem' target='_blank' rel='noopener noreferrer'>
<div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
<div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
<img className='group-hover:scale-125 transition-all duration-500' src={Img2} alt='' />
<div className='absolute -bottom-full left-12 group-hover:bottom-24 transaction-all duration-500 z50'><span className='text-gradient'>GYM MEMBERSHIP MANAGEMENT SYSTEM</span> </div>

<div className='absolute -bottom-full left-12 group-hover:bottom-14 transaction-all duration-700 z50'>
  <span className='text-3xl text-white'></span>
   </div>
</div>
</a>
</div>










<div
className='flex-1 flex flex-col gap-y-10'>
    <a href='https://github.com/Mapatano/genesisActuaries' target='_blank' rel='noopener noreferrer'>
<div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
<div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
<img className='group-hover:scale-125 transition-all duration-500' src={Img5} alt='' />
<div className='absolute -bottom-full left-12 group-hover:bottom-24 transaction-all duration-500 z50'><span className='text-gradient'>GENESIS ACTUARIES WEBSITE</span> </div>

<div className='absolute -bottom-full left-12 group-hover:bottom-14 transaction-all duration-700 z50'>
  <span className='text-3xl text-white'></span>
   </div>
</div>
</a>
</div>

























</div>
</div>
</div>
</section>
  );



};

export default Work;

